import {ReactNode} from 'react';
import {FileData, getFileURL} from '../../../app/pages/documents/api';
import {useDownloadFile} from '../Hooks/DocumentHooks';

interface DocumentDownloadButtonProps {
  file: FileData;
  className?: string;
  ariaLabel?: string;
  children: ReactNode;
}

/**
 * Bouton de téléchargement direct, sans lien copiable ni partageable.
 */
const DocumentDownloadButton = ({
  file,
  className,
  ariaLabel,
  children,
}: DocumentDownloadButtonProps): JSX.Element => {
  const {mutate} = useDownloadFile();

  return (
    <button
      type="button"
      className={className}
      aria-label={ariaLabel}
      onClick={() => mutate(getFileURL(file))}
    >
      {children}
    </button>
  );
};

export default DocumentDownloadButton;
